import { useState } from "react";
import MultipleChoiceOption from "../../../../common/components/inputFields/multipleChoiceOption/multipleChoiceOption";
import { OptionModel } from "../../../createCampaign/models/questionModel";
import "./campaignMultipleChoice.scss";

export default function CampaignMultipleChoice(props: {
  border?: string;
  color?: string;
  fontFamily?: string;
  optionsData?: OptionModel[];
  onChange?: (e: OptionModel) => void;
}) {
  const [selectedOption, setSelectedOption] = useState<OptionModel>();
  return (
    <div className="campaign-multiple-choose">
      {props.optionsData?.map((e, i) => (
        <MultipleChoiceOption
          key={i}
          initialValue={{ option: e.option }}
          viewOnly
          border={props.border ?? "2px solid rgba(255, 255, 255, 0.5)"}
          color={props.color ?? "rgba(255, 255, 255, 1)"}
          fontFamily={props.fontFamily}
          onClick={() => {
            setSelectedOption(e);
            props.onChange?.(e);
          }}
          isSelected={e == selectedOption}
        />
      ))}
    </div>
  );
}
